/* eslint-disable no-undef */
import { getWidget } from '@uvocore-front/utils';
import initStatisticsDisciplines from './initStatisticsDisciplines';

// run common page
const statisticsDisciplines = document.querySelector('[data-statistics-disciplines-widget]');
if (statisticsDisciplines) {
  getWidget({
    widgetLink: '/assets/js/statisticsDisciplinesWidget.min.js',
    // insertLoaderTo: '.StatisticsDisciplines',
    // loaderPosition: 'top',
    fn: initStatisticsDisciplines,
  });
}
